var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhonecall1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "phone-call_1_",
    "data-name": "phone-call (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.266,
    height: 19.306,
    viewBox: "0 0 19.266 19.306",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3038",
    "data-name": "Group 3038",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39321",
    "data-name": "Path 39321",
    d: "M19.3,14.169l-2.694-2.694a1.792,1.792,0,0,0-2.983.674A1.834,1.834,0,0,1,11.506,13.3a8.308,8.308,0,0,1-5-5A1.744,1.744,0,0,1,7.657,6.182,1.792,1.792,0,0,0,8.33,3.2L5.636.505a1.922,1.922,0,0,0-2.6,0L1.21,2.333C-.618,4.258,1.4,9.358,5.925,13.88S15.547,20.52,17.471,18.6L19.3,16.767A1.922,1.922,0,0,0,19.3,14.169Z",
    transform: "translate(-0.539 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonecall1);
export default __webpack_public_path__ + "static/media/phonecall1.0dd6219e83a206ec34f27ee3e628d5b3.svg";
export { ForwardRef as ReactComponent };